<header class="bg-[#f2f5f9] text-black border-b border-black/10 sticky top-0 z-[100]" style="z-index: 100;">
  <div class="w-full flex items-center" [class]="compact() ? 'h-[72px]' : 'h-16 md:h-[104px]'">
    <div class="header-start">
      @if (logoUrl()) {
        <img
          [src]="mobileLogoSrc()"
          [alt]="title() + ' Logo'"
          [class]="compact()
            ? 'h-12 w-12 object-contain md:hidden'
            : 'h-10 w-10 sm:h-12 sm:w-12 object-contain md:hidden'"
        />
        <img
          [src]="logoUrl()"
          [alt]="title() + ' Logo'"
          [class]="compact()
            ? 'hidden md:block h-14 w-auto max-w-none object-contain'
            : 'hidden md:block h-auto max-h-16 w-auto object-contain'"
        />
      }
      @if (showMenuButton()) {
        <button
          mat-icon-button
          (click)="menuToggle.emit()"
          class="header-menu-button text-black hover:bg-black/10 hover:text-black">
          <mat-icon>menu</mat-icon>
        </button>
      }
    </div>

    <div class="flex-1 flex flex-col justify-center px-2 md:px-4 min-w-0">
      <div
        class="flex items-center justify-between h-12 md:h-14"
        [class.header-row-end-mobile]="endOnMobile()">
        <div
          class="header-center"
          [class.header-center-with-menu]="showMenuButton()"
          [class.header-center-end-mobile]="endOnMobile()">
          <ng-content select="[headerCenter]"></ng-content>
        </div>

        <div class="header-end">
          <ng-content select="[headerEnd]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</header>

